module.exports = __webpack_public_path__ + "static/media/agentNotified2x.2bb3c56e.png";